// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3nc0A","paramInput":"JobSimulator_paramInput__1B5Je","input":"JobSimulator_input__21dYf"};